import { createApp } from 'vue'
import ContentSearchOverlay from './content-search.overlay.vue';
import SearchHistoryService from '@/services/searchHistoryService';


document.addEventListener('DOMContentLoaded', () => {
    const el = document.getElementById('suchformularContent');
    if (!el) return

    SearchHistoryService.create();
    const app= createApp(ContentSearchOverlay);
    app.mount( el );
})

